import * as Comlink from "comlink";
import { CorsWorker as Worker } from "@sandbox/utils";
import { TranspileWorker } from "./esbuild.worker";

let worker: globalThis.Worker;

if (process.env.NODE_ENV === "development" && process.env.VITE) {
  worker = new globalThis.Worker(new URL("./esbuild.worker.ts", import.meta.url), { type: "module" });
} else {
  const corsWorker = new Worker(new URL("./esbuild.worker.ts", import.meta.url));
  worker = corsWorker.getWorker();
}

export const transpiler = Comlink.wrap<TranspileWorker>(worker);

